export const GET_CLIENT_BY_ID = `
  query getClient($id: String!) {
    getClient(id: $id) {
      id
      cuentaCorriente
      saldoDolares
      saldoSoles
      paymentMethod {
        bank
        bankAccountNumber
        paymentType
        currency
        cci
        observacion
        nombreIntermediario
      }
      generalInformation {
        brandName
        businessAddress
        country
        postalCode
        email
        clientStatus
      }
      contact {
        name
        nationality
        position
        email
        phone
        location
        nationality
      }
    }
  }
`;

export const GET_CLIENT_BY_NAME = `
  query getClientbyName($name: String!) {
    getClientbyName(name: $name) {
      id
      cuentaCorriente
      saldoDolares
      saldoSoles
      generalInformation {
        brandName
        businessAddress
        country
        postalCode
        email
        clientStatus
      }
      contact {
        name
        nationality
        position
        email
        phone
        location
        nationality
      }
    }
  }
`;

export const GET_ALL_CLIENTS = `
  query{
    getAllClients{
      id,
      cuentaCorriente,
      cuentaCorrienteSoles,
      cuentaCorrienteDolares,
      saldoSoles,
      saldoDolares,
      lstBancario{
        banco,
        createdAt,
        moneda,
        monto,
        tipo,
        usuario
      },
      lstNotaCredito{
        codigo,
        createdAt,
        idNotaCredito,
        moneda,
        monto,
        tipo,
        usuario,
        estado,
        montoExcedente,
        noContabilizarSAF,
        isAjustePorVariacion,
      },
      lstPagos{
        idPago,
        tipoAbono,
        monto
      },
      generalInformation{
        brandName,
        businessAddress,
        country,
        postalCode,
        email,
        clientStatus
      },
      totalDepositos,
      totalNotaCredito,
      totalComisiones
    }
  }
`;
